import { WorkplanCurrentStatus } from '../Status';
import i18n from '../../../i18n';

export const getWorkplanCurrentStatusLabel = (statusId) => {
    const t = (status) => i18n.t(`workplanManager:workPlanList.workplanCurrentStatus.${status}`);

    switch (statusId) {
        case WorkplanCurrentStatus.Active:
            return t('active');
        case WorkplanCurrentStatus.Paused:
            return t('paused');
        case WorkplanCurrentStatus.Stopped:
            return t('stopped');
        case WorkplanCurrentStatus.Scheduled:
            return t('scheduled');
        case WorkplanCurrentStatus.Draft:
            return t('draft');
        default:
            return '';
    }
};

export const getAsyncTaskSuccessLabel = (selectedWorkPlan, t) => {
    if (selectedWorkPlan.isRollingOut) {
        return t('workPlan.successRolloutWorkplanCompleted');
    }
    else if (selectedWorkPlan.isPausing) {
        return t('workPlan.successPauseWorkplanCompleted');
    }
    else if (selectedWorkPlan.isStopping) {
        return t('workPlan.successStopWorkplanCompleted');
    }
    else if (selectedWorkPlan.isImportingExcel) {
        return t('workPlan.successImportExcelCompleted');
    }
    else if (selectedWorkPlan.isReloadingCoverage) {
        return t('workPlan.successReloadCoverageCompleted');
    }
}
